/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { Box, Typography } from "@mui/material";
import {
  BAY_ITEM_HEIGHT,
  BAY_ITEM_WIDTH,
  BaseAreaItemProps,
  HotkeyBadge,
  UNMAPPED_AREA_COLOR,
} from "./scrapEyeLayoutCommon";
import { formatArea } from "components/identifyEventsTool/utils/formatArea";

type BayItemProps = BaseAreaItemProps & {};

export const BayItem = ({
  areaId,
  displayName,
  onClick,
  isSelectable = true,
  hotkey,
  material,
  overrideColor,
  isSelected = false,
  isDimmed = false,
}: BayItemProps) => {
  const color = overrideColor ?? UNMAPPED_AREA_COLOR;

  return (
    <Box
      onClick={() => isSelectable && !isDimmed && onClick?.(areaId)}
      sx={{
        width: BAY_ITEM_WIDTH,
        height: BAY_ITEM_HEIGHT,
        bgcolor: color,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 1,
        border: isSelected ? 3 : 2,
        borderColor: isSelected ? "primary.main" : "divider",
        cursor: isSelectable && onClick && !isDimmed ? "pointer" : "default",
        transition: "all 0.15s ease-in-out",
        gap: 0.5,
        overflow: "hidden",
        opacity: isDimmed ? 0.35 : 1,
        filter: isDimmed ? "grayscale(0.7)" : undefined,
        boxShadow: isSelected
          ? "0 0 0 3px rgba(25, 118, 210, 0.4), 0 4px 12px rgba(0,0,0,0.3)"
          : undefined,
        "&:hover":
          isSelectable && onClick && !isDimmed
            ? {
                transform: "scale(1.05)",
                boxShadow: 4,
                borderColor: "primary.main",
              }
            : {},
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: "white",
          fontWeight: "bold",
          textShadow: "1px 1px 2px rgba(0,0,0,0.5)",
          fontSize: "0.7rem",
        }}
      >
        {displayName ?? formatArea(areaId)}
      </Typography>
      {hotkey ? <HotkeyBadge hotkey={hotkey} /> : null}
      {material ? (
        <Typography
          variant="caption"
          sx={{
            color: "white",
            textShadow: "1px 1px 2px rgba(0,0,0,0.5)",
            fontSize: "0.6rem",
            lineHeight: 1,
          }}
        >
          {material}
        </Typography>
      ) : null}
    </Box>
  );
};
